type FieldMapping = {
    [key: string]:
        | "kategori"
        | "nama"
        | "harga"
        | "stok"
        | "sku"
        | "kadaluarsa"
        | "totalHpp"
        | undefined;
};

export const mapStockFieldSorting = (
    fieldName: string,
): FieldMapping[keyof FieldMapping] => {
    const fieldMap: FieldMapping = {
        namaBarang: "nama",
        kategori: "kategori",
        hargaMultiple: "harga",
        stok: "stok",
        sku: "sku",
        expAt: "kadaluarsa",
        totalHpp: "totalHpp",
    };

    return fieldMap[fieldName];
};
